import { useEffect } from 'react';
import { useConfigCatClient } from 'configcat-react';
import { setConfigCatClient } from 'utills/featureFlags';

/**
 * Bridges the ConfigCat client from React context into utills/featureFlags.ts.
 * Must be rendered inside ConfigCatProvider. configcat-react only creates its
 * client inside the React tree, but flag checks also happen from plain
 * module-level code (e.g. utills/telemetry.ts) that can't use the hook, so
 * this publishes the client for that non-component code to read. Renders
 * nothing itself.
 */
export const ConfigCatClientBridge = (): null => {
  const client = useConfigCatClient();

  useEffect(() => {
    setConfigCatClient(client);
    return () => setConfigCatClient(null);
  }, [client]);

  return null;
};
